import { downArrow } from "../../icons/utils";
import { DownArrowIcon } from "../styles/DropdownArrow";

export const DropdownArrow = () => <DownArrowIcon src={downArrow} />;
